import React from 'react';
import { formatText, FormatTextOptions } from './utils';

export interface EditorTextDisplayProps {
  style?: React.CSSProperties;
  formatTextOptions?: FormatTextOptions;
  className?: string;
  children: React.ReactNode;
}

/**
 * A centralized component for rendering text content consistently throughout
 * the editors. This component serves as a single source of truth for text rendering,
 * ensuring that all text displays in editors follow the same formatting rules and
 * styling conventions.
 */
const EditorTextDisplay: React.FC<EditorTextDisplayProps> = ({
  style,
  formatTextOptions,
  className,
  children,
}) => {
  const formattedText = formatText(children, formatTextOptions);

  return (
    <span
      style={style}
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: formattedText,
      }}
    />
  );
};

export default EditorTextDisplay;
